import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { TurnstileService } from 'src/app/core/services/turnstile.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit, AfterViewInit {
  applicationId: string;
  @Input() programCode: string;
  templates: { [key: string]: TemplateRef<any> } = {};
  @ViewChild('avatarTemplate') avatarTemplate!: TemplateRef<any>;

  lastCall: number = Date.now() - 500;
  images: string[] = new Array();
  isExercisesGrid: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private turnstileService: TurnstileService,
    private helperService: HelpersService
  ) {}

  ngOnInit(): void {
    this.resetImages();
    this.route.params.subscribe((params) => {
      this.applicationId = params['id'];
      this.turnstileService.getUnitCode().subscribe((unitCode) => {
        this.turnstileService
          .getTurnstilesByUnitCode(unitCode)
          .pipe(take(1))
          .subscribe((response) => {
            this.programCode = response.value[0].programsCodes;
          });
      });
    });
  }

  ngAfterViewInit(): void {
    this.templates = {
      exerciseImage: this.avatarTemplate
    };
  }

  getImageColumn(row: any) {
    if (!row) return;
    if (row.difficultyLevel && row.exerciseType) this.isExercisesGrid = true;
    return this.images[row.index];
    const fieldColumn = row.column.field;
    if (fieldColumn == 'user') {
      return row['student'].user.avatar.avatarImage;
    }
  }

  onCompleted(event): void {
    if (!this.isExercisesGrid) return;
    if (!event?.rows?.length) return;
    if (Date.now() - this.lastCall < 200) {
      this.lastCall = Date.now();
      return;
    }
    this.lastCall = Date.now();
    this.resetImages();
    event.rows.forEach(async (row, i: number) => {
      this.images[i] = (await this.helperService.getImageById(row.data.id)).value[0].image;
      /* this.helperService.getImageById(row.data.id).then((response) => {
        this.images[i] = response.value[0].image;
      }); */
    });
  }

  resetImages(): void {
    this.images = [
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif',
      'assets/images/loading.gif'
    ];
  }
}
